import type React from 'react';
import { FileText, X } from 'lucide-react';
import { Button } from 'shared-portal-components-v2';

const BYTES_PER_KB = 1024;
const KB_DECIMAL_PLACES = 2;

function formatFileSize(sizeInBytes: number): string {
  return (sizeInBytes / BYTES_PER_KB).toFixed(KB_DECIMAL_PLACES);
}

interface FileUploadFileListProps {
  files: File[];
  onFileRemoved: (index: number) => void;
}

export default function FileUploadFileList({
  files,
  onFileRemoved,
}: FileUploadFileListProps): React.JSX.Element {
  return (
    <div className="max-h-60 space-y-2 overflow-y-auto">
      <h4 className="text-sm font-medium">Files to upload:</h4>
      {files.map((file, index) => (
        <div
          key={`${file.name}-${String(file.lastModified)}`}
          className="flex items-center gap-3 rounded-lg border p-3"
        >
          <FileText className="h-4 w-4 shrink-0 text-muted-foreground" />
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-medium">{file.name}</p>
            <p className="text-xs text-muted-foreground">{formatFileSize(file.size)} KB</p>
          </div>
          <Button
            variant="tertiary"
            size="sm"
            className="shrink-0"
            onClick={() => {
              onFileRemoved(index);
            }}
            aria-label={`Remove ${file.name}`}
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      ))}
    </div>
  );
}
